var Pixel = Pixel || {};

Pixel.Insider = (function (PixelBase) {

    var insiderObj = PixelBase.extend({
        purchaseSuccess: function () {
            window.insider_object = {
                "page": {
                    "type": "Confirmation"
                }
            };
            Insider.eventManager.dispatch('init-manager:re-initialize');
        }
    });

    return insiderObj;
})(Pixel.PixelBase);

!function (Pixel) {
    new Pixel.Insider();
}(Pixel);